// import Repository from '@/libs/axios'
import OperationRepository from '@/libs/customAxios/operationAxios'

const getColor = '/settings/theme-color-ui'

export default {
  getColor() {
    return OperationRepository.get(`${getColor}`)
  },
}
